import {StatusBox, StatusTitle} from "./components/styled";
import colors from "../../../newShared/theme/colors";
import {HrIssuesStatus, HrRequestStatus, HrTimeOffStatus, HrTimeOffStepsStatus} from "../../../newShared/GQLTypes";
import dagre, {graphlib} from "dagre";
import {Edge, Node, Position} from "reactflow";


export const getRequestStatusChip = (status: HrRequestStatus, isFilter?: boolean) => {
    switch (status) {
        case HrRequestStatus.Created: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_5}><StatusTitle color={colors.decorative.lilac}>{'Created'}</StatusTitle></StatusBox>;
        case HrRequestStatus.Approved: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_3}><StatusTitle color={colors.text.success}>{'Approved'}</StatusTitle></StatusBox>;
        case HrRequestStatus.Rejected: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_2}><StatusTitle color={colors.text.critical}>{'Rejected'}</StatusTitle></StatusBox>;
        case HrRequestStatus.Cancelled: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.backgrounds.grey_light}><StatusTitle color={colors.text.grey}>{'Cancelled'}</StatusTitle></StatusBox>;
        default:  return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.backgrounds.grey_light}><StatusTitle color={colors.text.grey}>{status}</StatusTitle></StatusBox>;
    }
}

export const getIssueStatusChip = (status: HrIssuesStatus, isFilter?: boolean) => {
    switch (status) {
        case HrIssuesStatus.Reported: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_5}><StatusTitle color={colors.decorative.lilac}>{'Reported'}</StatusTitle></StatusBox>;
        case HrIssuesStatus.Resolved: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_3}><StatusTitle color={colors.text.success}>{'Resolved'}</StatusTitle></StatusBox>;
        case HrIssuesStatus.InProgress: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_1}><StatusTitle color={colors.decorative.violet}>{'In progress'}</StatusTitle></StatusBox>;
        // case RequestStatus.Cancelled: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} color={colors.stroke.grey}><StatusTitle color={colors.text.grey}>{status}</StatusTitle></StatusBox>;
        default:  return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_4}><StatusTitle color={colors.text.dark}>{status}</StatusTitle></StatusBox>;
    }
}

export const getTimeOffStatusChip = (status: HrTimeOffStatus, isFilter?: boolean) => {
    switch (status) {
        case HrTimeOffStatus.Created: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_1}><StatusTitle color={colors.text.grey_dark}>{'Created'}</StatusTitle></StatusBox>;
        case HrTimeOffStatus.Rejected: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={'#FEE4E2'}><StatusTitle color={'#B42318'}>{'Rejected'}</StatusTitle></StatusBox>;
        case HrTimeOffStatus.Approval: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={'#E3F2FD'}><StatusTitle color={colors.text.success}>{'Approval'}</StatusTitle></StatusBox>;
        case HrTimeOffStatus.Approved: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={'#D1FADF'}><StatusTitle color={colors.text.success}>{'Approved'}</StatusTitle></StatusBox>;
        case HrTimeOffStatus.Cancelled: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={'#EDEBE9'}><StatusTitle color={'#B42318'}>{'Cancelled'}</StatusTitle></StatusBox>;
        default:  return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_4}><StatusTitle color={colors.text.dark}>{status}</StatusTitle></StatusBox>;
    }
}

export const getTimeOffStepStatusChip = (status: HrTimeOffStepsStatus, isFilter?: boolean) => {
    switch (status) {
        case HrTimeOffStepsStatus.Created: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.status.violet_1}><StatusTitle color={colors.textStatus.neutral}>{'Created'}</StatusTitle></StatusBox>;
        case HrTimeOffStepsStatus.Rejected: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.status.red_1}><StatusTitle color={colors.textStatus.negative}>{'Rejected'}</StatusTitle></StatusBox>;
        case HrTimeOffStepsStatus.Approved: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.status.green_3}><StatusTitle color={colors.textStatus.positive}>{'Approved'}</StatusTitle></StatusBox>;
        case HrTimeOffStepsStatus.Skipped: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.backgrounds.grey_light}><StatusTitle color={colors.textStatus.neutral}>{'Skipped'}</StatusTitle></StatusBox>;
        case HrTimeOffStepsStatus.InProgress: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.status.blue_2}><StatusTitle color={colors.textStatus.neutral}>{'In progress'}</StatusTitle></StatusBox>;
        case HrTimeOffStepsStatus.Pending: return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.status.grey_2}><StatusTitle color={colors.textStatus.neutral}>{'Pending'}</StatusTitle></StatusBox>;
        default:  return <StatusBox margin={isFilter ? '8px 0 0 0' : undefined} bgColor={colors.decorative.background_4}><StatusTitle color={colors.text.dark}>{status}</StatusTitle></StatusBox>;
    }
}

// /// // /// / // // Tree:

export type TEmployeeNodeData = {
    id: string;
    name: string;
    logo?: string | null;
    manager?: string | null;

    jobTitle?: string | null;
    department?: string | null;

    workMobilePhone?: string | null;
    workEmail?: string | null;

    isDeleted: boolean;
}

export const employeeTreeNodeWidth = 260;
export const employeeTreeNodeHeight = 109;
export const getLayoutedElements = (dagreGraph: graphlib.Graph<{}>, nodes: Node<TEmployeeNodeData>[], edges: Edge[], direction = 'TB'): {nodes: Node<TEmployeeNodeData>[], edges: Edge[]} => {
    const isHorizontal = direction === 'LR' || direction === 'RL';
    dagreGraph.setGraph({
        rankdir: direction,
        edgesep: 10,
        nodesep: 20,
        ranksep: 35,
    });

    nodes.forEach((node, index, array) => {
        dagreGraph.setNode(node.id, { width: employeeTreeNodeWidth, height: employeeTreeNodeHeight });
        dagreGraph.setParent(node.id, node.id + ' Group');
    });

    edges.forEach((edge) => {
        dagreGraph.setEdge(edge.source, edge.target);
        dagreGraph.setParent(edge.target + ' Group', edge.source + ' Group');
    });

    dagre.layout(dagreGraph);

    nodes.forEach((node) => {
        const nodeWithPosition = dagreGraph.node(node.id);
        // node.targetPosition = isHorizontal ? direction === 'LR' ? Position.Left : Position.Right : Position.Top;
        // node.sourcePosition = isHorizontal ? direction === 'RL' ? Position.Right : Position.Left : Position.Bottom;
        node.targetPosition = isHorizontal ? direction === 'LR' ? Position.Left : Position.Right : Position.Top;
        node.sourcePosition = isHorizontal ? direction === 'LR' ? Position.Right : Position.Left : Position.Bottom;

        // We are shifting the dagre node position (anchor=center center) to the top left
        // so it matches the React Flow node anchor point (top left).
        node.position = {
            x: nodeWithPosition.x - employeeTreeNodeWidth / 2,
            y: nodeWithPosition.y - employeeTreeNodeHeight / 2,
        };

        return node;
    });

    return { nodes, edges };
};
